import $ from 'jquery';

require('spectrum-colorpicker');

export default function bind() {
  colorpicker($('input.color'));
}

export function colorpicker($element) {
  return $element.spectrum({
    allowEmpty: true,
    chooseText: 'Valider',
    cancelText: 'Annuler',
    showInput: true,
    preferredFormat: 'hex',
  });
}



// WEBPACK FOOTER //
// ./src/plugins/color.js